export type DistrictConfig = {
  usesFlashlight: boolean;
};

export function getDistrictConfig(): DistrictConfig {
  return { usesFlashlight: true };
}
